import {
  ProductRealmSchema
} from "../chunk-HJPR3SS7.js";

// category/category.schema.ts
import { z } from "zod";
var DbCategorySchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  parent_id: z.string().nullable(),
  realm: ProductRealmSchema.default("cannabis"),
  created_at: z.string(),
  updated_at: z.string()
});
var CategorySchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  parentId: z.string().nullable(),
  realm: ProductRealmSchema.default("cannabis"),
  createdAt: z.date(),
  updatedAt: z.date()
});
var CategoryDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  parentId: z.string().nullable(),
  realm: ProductRealmSchema.default("cannabis"),
  createdAt: z.string(),
  updatedAt: z.string()
});
export {
  CategoryDtoSchema,
  CategorySchema,
  DbCategorySchema
};
